export default {
  home: 'Dashboard',
  new_job: 'Post a Job',
  manageJobs: 'Manage Jobs',
  manageShifts: 'Manage Schedules',
  templates: 'Templates',
  messages: 'Messages',
  workforce: {
    title: 'Workforce',
    teams: 'Teams',
    wonoloers: 'Wonoloers',
  },
  reports: {
    title: 'Reports',
    usage: 'Usage',
    transactions: 'Transactions',
    time_attendance: 'Time and Attendance',
    jobs: 'Jobs',
    summary: 'Summary',
    invoice: 'Invoice',
    enterpriseOverview: 'Enterprise Overview',
  },
  settings: {
    title: 'Account',
    company: 'Company',
    myInfo: 'My Info',
    preferences: 'Notification Preferences',
    wandas: 'Wandas',
  },
  support: {
    title: 'Support',
    faq: 'FAQ',
    contact: 'Contact Us',
  },
  management: {
    title: 'Manage',
    jobs: 'Jobs',
    position: 'Positions',
    location: 'Locations',
    schedule: 'Schedules',
    wonoloer: 'Wonoloers',
    team: 'My teams',
  },
  logout: 'Sign out',
  payments: 'Payments',
};
